export default "__VITE_ASSET__Cqa2mZrD__"